import React from 'react';
import './styles.css';
import P from 'prop-types';

export const Loading = ({ param }) => {
  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <div id="loader" style={{ margin: '17px auto' }}>
        <div className="bubblingG">
          <span id="bubblingG_1"></span>
          <span id="bubblingG_2"></span>
          <span id="bubblingG_3"></span>
        </div>
        {param?.msg}
      </div>
    </div>
  );
};

Loading.propTypes = {
  param: P.object,
};
